import React, { useState } from "react";
import axios from "axios";
import { API, useAuth } from "@/App";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { User, Phone } from "lucide-react";

export default function OnboardingModal() {
  const { user, setUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [mobile, setMobile] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !mobile.trim()) { toast.error("Please fill in name and mobile number"); return; }
    if (mobile.length < 10) { toast.error("Please enter a valid mobile number"); return; }
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/auth/onboard`, { name: name.trim(), mobile: mobile.trim() }, { withCredentials: true });
      setUser(res.data); toast.success("Profile updated successfully");
    } catch (err) { toast.error(err.response?.data?.detail || "Failed to save profile"); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-xl" data-testid="onboarding-modal">
      <div className="glass rounded-3xl w-full max-w-md p-8 fade-in-up">
        <div className="text-center mb-6">
          <div className="w-14 h-14 bg-emerald-400/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <User className="w-7 h-7 text-emerald-400" />
          </div>
          <h2 className="text-2xl font-bold text-white tracking-tight">Complete Your Profile</h2>
          <p className="text-sm text-zinc-500 mt-1 font-light">We need a few details to get started</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label className="label-sm mb-2 block">Full Name *</Label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-600" />
              <Input data-testid="onboard-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your full name"
                className="h-11 rounded-xl text-sm pl-10 bg-white/5 border-white/10 text-white placeholder:text-zinc-600" />
            </div>
          </div>
          <div>
            <Label className="label-sm mb-2 block">Mobile Number *</Label>
            <div className="relative">
              <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-600" />
              <Input data-testid="onboard-mobile" value={mobile} onChange={(e) => setMobile(e.target.value.replace(/\D/g, "").slice(0, 10))} placeholder="10-digit mobile number"
                className="h-11 rounded-xl text-sm font-mono pl-10 bg-white/5 border-white/10 text-white placeholder:text-zinc-600" />
            </div>
          </div>
          <Button data-testid="onboard-submit" type="submit" disabled={submitting}
            className="w-full text-sm font-semibold bg-emerald-400 text-black hover:bg-emerald-300 h-12 rounded-xl">
            {submitting ? "SAVING..." : "GET STARTED"}
          </Button>
        </form>
      </div>
    </div>
  );
}
